module.exports = __webpack_public_path__ + "img/kn.c991c407.svg";